
import { Point } from './Point';
import { cms_logging } from './cms_logging';
import { Rectangle } from './Rectangle';
import { Id_attachment, Id_location, Id_floor } from './api/Identifiers';




interface AttachmentJSON {
    id: string,
    url: string,
    id_location: number,
    location: string,
    adj_coords: number[];
    adj_geo_ref: any[];
    //    coords: number[];
    icon: string;
    is_3D_link: boolean;
    is_video_link: boolean;
    is_image: boolean;
    is_link: boolean;
    raw_coords: number[];
    raw_geo_ref: any[];
    raw: any
}


export class Attachment {
    private static readonly ICON_3D_LINK: string = 'https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/icons/48/360.png';
    private static readonly ICON_IMAGE: string = 'https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/icons/48/camera.png';
    private static readonly ICON_VIDEO: string = 'https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/icons/48/video-tiny.png';

    public get is_3D_link(): boolean {
        return this.url.includes('my.matterport.com')
    }

    public get is_video_link(): boolean {
        let rtnVal:boolean = false;
        if (this.url.includes('youtube.com')){
            rtnVal = true;
        }
        //NOTE: youtu.be links do not work!!
        return rtnVal;
    }

    public get is_image(): boolean {
        // var png = this.url.endsWith(".png");
        // var jpeg = this.url.endsWith(".jpeg");
        return (this.url.endsWith(".jpeg") || this.url.endsWith(".png"));
    }

    public get is_link(): boolean {
        return (this.is_video_link || this.is_3D_link);
    }

    constructor(readonly id: Id_attachment,
        readonly url: string,
        readonly coord: Point,
        readonly p1: Point,
        readonly p2: Point,
        readonly location: string,
        readonly id_location: Id_location,
        readonly raw: any) { }

    public get icon(): string {
        if (this.is_3D_link) {
            return Attachment.ICON_3D_LINK;
        }
        else if (this.is_video_link) {
            return Attachment.ICON_VIDEO;
        }
        return Attachment.ICON_IMAGE;
    }

    public toJson(): AttachmentJSON {
        const r: AttachmentJSON = {
            raw_geo_ref: [this.p1.toJSON(), this.p2.toJSON()],
            adj_geo_ref: [this.p1.toJSON(), this.p2.toJSON()],
            adj_coords: this.coord.toJSON(),
            raw_coords: this.coord.toJSON(),
            id: this.id.value,
            id_location: this.id_location.value,
            location: this.location,
            url: this.url,
            icon: this.icon,
            is_3D_link: this.is_3D_link,
            is_video_link: this.is_video_link,
            is_image: this.is_image,
            is_link: this.is_link,
            raw: this.raw
        };
        return r;
    }

    public static build_from_raw(raw_attachment: any): Attachment {
        // check for required values
        if (!raw_attachment.id) {
            cms_logging.api_error(`missing 'id'`, ``, `getattachmentsbylocation`, raw_attachment);
            return null;
        }
        let fail = false;

        ['xCoord', 'yCoord', 'p1xCoord', 'p1yCoord', 'p2xCoord', 'p2yCoord', 'url', 'idLocation'].forEach(key => {
            if (!raw_attachment[key]) {
                cms_logging.api_error(`missing '${key}'`, `${raw_attachment.id}`, `getattachmentsbylocation`, raw_attachment);
                fail = true;
            }
        })
        if (fail) {
            return null;
        }
        return new Attachment(
            Id_attachment.wrap(raw_attachment.id),
            raw_attachment.url,
            Point.build(raw_attachment.xCoord,
                raw_attachment.yCoord),
            Point.build(raw_attachment.p1xCoord,
                raw_attachment.p1yCoord),
            Point.build(raw_attachment.p2xCoord,
                raw_attachment.p2yCoord),
            raw_attachment.location,
            Id_location.wrap(raw_attachment.idLocation),
            raw_attachment
        );
    }


}

export class AttachmentCollection {
    public static empty(): AttachmentCollection { return new AttachmentCollection(); };

    public static wrap(attachments: Attachment[]) {
        let r: AttachmentCollection = new AttachmentCollection();
        attachments.forEach((a: Attachment) => {
            r.update(a)

        })
        return r;
    }

    private update(attachemnt: Attachment): AttachmentCollection {
        this._temp_attachments_list = [];
        this._attachments_tree[attachemnt.id.value] = attachemnt;
        return this;
    }
    private _temp_attachments_list: Attachment[] = [];
    private _attachments_tree: any = {};
    public extend(lhs: AttachmentCollection): AttachmentCollection {
        if (lhs) {
            lhs.attachments.forEach((a: Attachment) => {
                this.update(a);
            });
        }
        return this;
    }

    public get attachments(): Attachment[] {
        if (this._temp_attachments_list.length == 0) {
            for (const key in this._attachments_tree) {
                let a: Attachment = this._attachments_tree[key];
                this._temp_attachments_list.push(a);
            }
        }

        return this._temp_attachments_list;
    }
    public get count(): number {
        return this.attachments.length;
    }

    public filter(id_location: Id_location): AttachmentCollection {
        let r: AttachmentCollection = new AttachmentCollection();
        this.attachments.forEach((attachment: Attachment) => {
            if (attachment.id_location.equals(id_location)) {
                r.update(attachment);
            }
        });
        return r;
    }
    public static build_from_raw(raw_attachments: any[]): AttachmentCollection {
        let r: AttachmentCollection = new AttachmentCollection();
        raw_attachments.forEach(element => {
            let a: Attachment = Attachment.build_from_raw(element);
            if (a) {
                r.update(a);
            }
        });
        return r;
    }

    /**
     * 
     */
    public get_for_floor(id_location: Id_location): AttachmentCollection {
        let a: Attachment[] = this.attachments.filter((a: Attachment) => {
            return a.id_location === id_location;
        })
        return AttachmentCollection.wrap(a);
    }
    public get as_json_by_floor(): any {
        let r: any = {}
        this.attachments.forEach((attachment: Attachment) => {
            let id_floor = attachment.id_location.toString();
            if (!(id_floor in r)) {
                r[id_floor] = {}
            }
            r[id_floor][attachment.id.toString()] = attachment.toJson();
        });
        return r;
    }

}

/**
 * 

[
  {
    "id": "14b8180a-4570-497e-93af-d952840952a5",
    "url": "https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/attachments/cms-test1/1/11/81084/14b8180a-4570-497e-93af-d952840952a5.jpg",
    "idLocation": 81084,
    "location": "04TH FLOOR",
    "xCoord": 4960,
    "yCoord": 7472,
    "p1xCoord": 610,
    "p1yCoord": 12044,
    "p2xCoord": 14075,
    "p2yCoord": 5419
  },
  {
    "id": "d0bc4cff-90ad-4eba-b604-fc0487db3b3d",
    "url": "https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/attachments/cms-test1/1/11/81084/d0bc4cff-90ad-4eba-b604-fc0487db3b3d.png",
    "idLocation": 81084,
    "location": "04TH FLOOR",
    "xCoord": 14784,
    "yCoord": 7200,
    "p1xCoord": 610,
    "p1yCoord": 12044,
    "p2xCoord": 14075,
    "p2yCoord": 5419
  }
]

 * 
 */


// WEBPACK FOOTER //
// ./src/ts/Attachment.ts